import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ENTER } from '@angular/cdk/keycodes';
import { IconNames } from '../../common/constants';
import { parseChipsInputBulkDataEntry, removeInputElement } from '../../common/utils';
import { AutoUnsubscribe } from '../../common/decorators';
import { Subscription } from 'rxjs';
import { debounceTime, filter } from 'rxjs/operators';
import { remove } from 'lodash';

@Component({
  selector: 'ui-chips-with-search',
  templateUrl: './chips-with-search.component.html',
  styleUrls: ['./chips-with-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
@AutoUnsubscribe
export class ChipsWithSearchComponent implements OnInit {
  @Input() label: string;
  @Input() isIconVisible = true;
  @Input() removable = true;
  @Input() set itemOptions(items: string[]) {
    if (items) {
      this.filteredItems = this.filterOptions(this.itemInputControl, this.selectedItemsControl, items);
    }
  }
  @Input() selectedItemsControl: UntypedFormControl;
  @Input() selectedItems: string[];
  @Output() fetchItemsOptions = new EventEmitter<string>();

  itemInputControl: UntypedFormControl = new UntypedFormControl('');
  separatorKeysCodes: number[] = [ENTER];
  filteredItems: string[] = [];
  subscriptions: Subscription[] = [];
  removeElement = removeInputElement;
  inputValue: string;
  iconNameList = IconNames;

  ngOnInit(): void {
    this.initInputControl(this.itemInputControl, this.fetchItemsOptions);
  }

  addOptionElement(control: UntypedFormControl, input: HTMLInputElement, inputControl: UntypedFormControl): void {
    const { value } = inputControl;
    if ((value || '').trim()) {
      const controlValue = remove(control.value, (item: string) => item !== this.inputValue);
      control.setValue(controlValue.concat(value.trim()));
      control.markAsDirty();
      this.inputValue = null;
    }
    if (input) {
      input.value = '';
    }
    inputControl.setValue(null);
    this.resetOptions();
  }

  addElement(control: UntypedFormControl, input: HTMLInputElement, inputControl: UntypedFormControl): void {
    this.inputValue = input.value;
    parseChipsInputBulkDataEntry(control, input, inputControl);
  }

  private filter(optionList: string[], value: string): string[] {
    const filterValue = value.toLowerCase();

    return optionList.filter((element: string) => element.toLowerCase().includes(filterValue));
  }

  private filterOptions(
    inputControl: UntypedFormControl,
    selectedOptionsControl: UntypedFormControl,
    allOptions: string[],
  ): string[] {
    const { value } = inputControl;
    const selectedOptions = selectedOptionsControl && selectedOptionsControl.value;

    allOptions = allOptions.filter(
      (option: string) => !selectedOptions.some((selectedOption: string) => option === selectedOption),
    );
    return value ? this.filter(allOptions, value) : allOptions.slice();
  }

  private initInputControl(control: UntypedFormControl, emitter: EventEmitter<string>): void {
    this.subscriptions.push(
      control.valueChanges.pipe(debounceTime(500), filter(Boolean)).subscribe((value: string) => {
        emitter.emit(value);
      }),
    );
  }

  private resetOptions(): void {
    this.filteredItems = [];
  }
}
